import { WrapUp } from "@/common/models/wrapUp";
import { Client, Controller, mapUrl, Endpoint } from "@/repository";

export const fetchWrapUp = async (): Promise<WrapUp> => {
	const url = mapUrl(Controller.AgentCall, Endpoint.WrapUp);

	return Client.instance.get(url);
};

export const stopMessagingWrapUp = async (): Promise<any> => {
	const url = mapUrl(Controller.Messaging, Endpoint.Stop, Endpoint.WrapUp);

	return Client.instance.post(url);
};
